// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.footer {
  background: linear-gradient(135deg, #0f172a 0%, #1e293b 50%, #0f172a 100%);
  color: white;
  width: 100%;
  padding: 60px 40px 30px;
  box-sizing: border-box;
  position: relative;
  overflow: hidden;
}

.footer::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(90deg, #667eea 0%, #764ba2 50%, #667eea 100%);
}

.footer::after {
  content: '';
  position: absolute;
  top: -50%;
  right: -10%;
  width: 400px;
  height: 400px;
  background: radial-gradient(circle, rgba(102, 126, 234, 0.1) 0%, transparent 70%);
  pointer-events: none;
}

.footer-main {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  flex-wrap: wrap;
  gap: 50px;
  max-width: 1200px;
  margin: 0 auto;
  position: relative;
  z-index: 1;
}

.footer-brand {
  flex: 1 1;
  min-width: 250px;
}

.footer-brand h3 {
  margin: 0;
  font-size: 28px;
  font-weight: 800;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  letter-spacing: -0.5px;
}

.footer-brand p {
  margin-top: 12px;
  font-size: 15px;
  opacity: 0.8;
  line-height: 1.6;
  color: #94a3b8;
}

.footer-links {
  display: flex;
  gap: 80px;
  flex-wrap: wrap;
}

.footer-links > div {
  min-width: 150px;
}

.footer-links h4 {
  font-size: 14px;
  margin-bottom: 20px;
  color: #667eea;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 1px;
}

.footer-links a {
  display: block;
  text-decoration: none;
  color: #cbd5e1;
  font-size: 14px;
  margin-bottom: 12px;
  transition: all 0.3s ease;
  position: relative;
  padding-left: 0;
}

.footer-links a::before {
  content: '';
  position: absolute;
  left: 0;
  bottom: -2px;
  width: 0;
  height: 2px;
  background: linear-gradient(90deg, #667eea 0%, #764ba2 100%);
  transition: width 0.3s ease;
}

.footer-links a:hover {
  color: white;
  padding-left: 10px;
}

.footer-links a:hover::before {
  width: calc(100% - 10px);
}

.footer-bottom {
  margin-top: 50px;
  padding-top: 25px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 1200px;
  margin-left: auto;
  margin-right: auto;
  position: relative;
  z-index: 1;
}

.footer-bottom p {
  margin: 0;
  color: #64748b;
  font-size: 14px;
}

.footer-bottom span {
  color: #64748b;
  font-size: 14px;
  padding: 6px 14px;
  background: rgba(255, 255, 255, 0.05);
  border-radius: 20px;
}

.footer-social {
  display: flex;
  gap: 16px;
  margin-top: 20px;
}

.footer-social a {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 10px;
  color: #cbd5e1;
  font-size: 18px;
  transition: all 0.3s ease;
}

.footer-social a:hover {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  transform: translateY(-3px);
}

@media (max-width: 900px) {
  .footer {
    padding: 50px 30px 25px;
  }
  
  .footer-main {
    gap: 40px;
  }
  
  .footer-links {
    gap: 50px;
  }
}

@media (max-width: 768px) {
  .footer {
    padding: 40px 20px 20px;
  }
  
  .footer-main {
    flex-direction: column;
    gap: 30px;
  }
  
  .footer-brand {
    text-align: center;
  }
  
  .footer-links {
    justify-content: center;
    gap: 40px;
    width: 100%;
  }
  
  .footer-links > div {
    text-align: center;
    min-width: 120px;
  }
  
  .footer-links a:hover {
    padding-left: 0;
  }
  
  .footer-links a::before {
    display: none;
  }
  
  .footer-bottom {
    flex-direction: column;
    gap: 12px;
    text-align: center;
  }
  
  .footer-social {
    justify-content: center;
  }
}

@media (max-width: 480px) {
  .footer-brand h3 {
    font-size: 24px;
  }
  
  .footer-links {
    gap: 25px;
  }
  
  .footer-links h4 {
    font-size: 12px;
    margin-bottom: 15px;
  }
  
  .footer-links a {
    font-size: 13px;
    margin-bottom: 10px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Footer.css"],"names":[],"mappings":"AAAA;EACE,0EAA0E;EAC1E,YAAY;EACZ,WAAW;EACX,uBAAuB;EACvB,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,yEAAyE;AAC3E;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,YAAY;EACZ,aAAa;EACb,iFAAiF;EACjF,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,eAAe;EACf,SAAS;EACT,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,6DAA6D;EAC7D,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,YAAY;EACZ,QAAQ;EACR,WAAW;EACX,4DAA4D;EAC5D,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,8CAA8C;EAC9C,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,qCAAqC;EACrC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oCAAoC;EACpC,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,2BAA2B;AAC7B;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,SAAS;EACX;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,uBAAuB;IACvB,SAAS;IACT,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,SAAS;IACT,kBAAkB;EACpB;;EAEA;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;AACF","sourcesContent":[".footer {\n  background: linear-gradient(135deg, #0f172a 0%, #1e293b 50%, #0f172a 100%);\n  color: white;\n  width: 100%;\n  padding: 60px 40px 30px;\n  box-sizing: border-box;\n  position: relative;\n  overflow: hidden;\n}\n\n.footer::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 4px;\n  background: linear-gradient(90deg, #667eea 0%, #764ba2 50%, #667eea 100%);\n}\n\n.footer::after {\n  content: '';\n  position: absolute;\n  top: -50%;\n  right: -10%;\n  width: 400px;\n  height: 400px;\n  background: radial-gradient(circle, rgba(102, 126, 234, 0.1) 0%, transparent 70%);\n  pointer-events: none;\n}\n\n.footer-main {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  flex-wrap: wrap;\n  gap: 50px;\n  max-width: 1200px;\n  margin: 0 auto;\n  position: relative;\n  z-index: 1;\n}\n\n.footer-brand {\n  flex: 1;\n  min-width: 250px;\n}\n\n.footer-brand h3 {\n  margin: 0;\n  font-size: 28px;\n  font-weight: 800;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n  letter-spacing: -0.5px;\n}\n\n.footer-brand p {\n  margin-top: 12px;\n  font-size: 15px;\n  opacity: 0.8;\n  line-height: 1.6;\n  color: #94a3b8;\n}\n\n.footer-links {\n  display: flex;\n  gap: 80px;\n  flex-wrap: wrap;\n}\n\n.footer-links > div {\n  min-width: 150px;\n}\n\n.footer-links h4 {\n  font-size: 14px;\n  margin-bottom: 20px;\n  color: #667eea;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n}\n\n.footer-links a {\n  display: block;\n  text-decoration: none;\n  color: #cbd5e1;\n  font-size: 14px;\n  margin-bottom: 12px;\n  transition: all 0.3s ease;\n  position: relative;\n  padding-left: 0;\n}\n\n.footer-links a::before {\n  content: '';\n  position: absolute;\n  left: 0;\n  bottom: -2px;\n  width: 0;\n  height: 2px;\n  background: linear-gradient(90deg, #667eea 0%, #764ba2 100%);\n  transition: width 0.3s ease;\n}\n\n.footer-links a:hover {\n  color: white;\n  padding-left: 10px;\n}\n\n.footer-links a:hover::before {\n  width: calc(100% - 10px);\n}\n\n.footer-bottom {\n  margin-top: 50px;\n  padding-top: 25px;\n  border-top: 1px solid rgba(255, 255, 255, 0.1);\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  max-width: 1200px;\n  margin-left: auto;\n  margin-right: auto;\n  position: relative;\n  z-index: 1;\n}\n\n.footer-bottom p {\n  margin: 0;\n  color: #64748b;\n  font-size: 14px;\n}\n\n.footer-bottom span {\n  color: #64748b;\n  font-size: 14px;\n  padding: 6px 14px;\n  background: rgba(255, 255, 255, 0.05);\n  border-radius: 20px;\n}\n\n.footer-social {\n  display: flex;\n  gap: 16px;\n  margin-top: 20px;\n}\n\n.footer-social a {\n  width: 40px;\n  height: 40px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(255, 255, 255, 0.1);\n  border-radius: 10px;\n  color: #cbd5e1;\n  font-size: 18px;\n  transition: all 0.3s ease;\n}\n\n.footer-social a:hover {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n  transform: translateY(-3px);\n}\n\n@media (max-width: 900px) {\n  .footer {\n    padding: 50px 30px 25px;\n  }\n  \n  .footer-main {\n    gap: 40px;\n  }\n  \n  .footer-links {\n    gap: 50px;\n  }\n}\n\n@media (max-width: 768px) {\n  .footer {\n    padding: 40px 20px 20px;\n  }\n  \n  .footer-main {\n    flex-direction: column;\n    gap: 30px;\n  }\n  \n  .footer-brand {\n    text-align: center;\n  }\n  \n  .footer-links {\n    justify-content: center;\n    gap: 40px;\n    width: 100%;\n  }\n  \n  .footer-links > div {\n    text-align: center;\n    min-width: 120px;\n  }\n  \n  .footer-links a:hover {\n    padding-left: 0;\n  }\n  \n  .footer-links a::before {\n    display: none;\n  }\n  \n  .footer-bottom {\n    flex-direction: column;\n    gap: 12px;\n    text-align: center;\n  }\n  \n  .footer-social {\n    justify-content: center;\n  }\n}\n\n@media (max-width: 480px) {\n  .footer-brand h3 {\n    font-size: 24px;\n  }\n  \n  .footer-links {\n    gap: 25px;\n  }\n  \n  .footer-links h4 {\n    font-size: 12px;\n    margin-bottom: 15px;\n  }\n  \n  .footer-links a {\n    font-size: 13px;\n    margin-bottom: 10px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
